import React, { Fragment, useState } from "react";
import Footer from "../pages/Footer";
import { images } from "../../common/Images";
import Header from "../pages/Header";
import "../aboutUs/Aboutus.css";
import { height } from "@mui/system";
import WhoWeAre from "./WhoWeAre";
import OurProcess from "./OurProcess";
import OurTeam from "./OurTeam";
import ProductService from "./ProductService";
import WhoJeleso from "./WhoJeleso";
import { Colors } from "../../common/Const";
const Aboutus = () => {

  const aboutus = [
    { id: 1, title: "Who We are", component:<WhoWeAre /> },
    { id: 2, title: "Our Process", component:<OurProcess /> },
    { id: 3, title: "Our Team", component:<OurTeam /> },
    { id: 4, title: "Product Service", component:<ProductService /> },
    { id: 5, title: "Who Kamadhenu", component:<WhoJeleso /> },
  ];
  const [activeTab,setActiveTab] = useState(0);
  const changeActive =(i) =>{
    setActiveTab(i);
  }
  return (
    <Fragment>
      <Header make={true} />
      <div className="aboutuses ">
        <div
          className="banner-img "
          style={{
            backgroundImage: `url(${images.about_main})`,
          }}
        >
          <div className="banner-text row ">
            <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-2"></div>
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-4">
              <span className="abtus-title">About Us</span> <br></br>
              <p className="abts-detls p-1">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of
                Lorem Ipsum.
              </p>
            </div>
            <div className="col-xxl-6 col-xl-4 col-lg-6 col-md-6 col-4 offset-6"></div>
          </div>
        </div>
        <div className="pt-4 pb-5 bottom">
          <div className="abouts-categories">
            {aboutus.map((titles,i) => {
              return <span  style={{color:activeTab == i ? Colors.Base_color : "gray",cursor:"pointer"}} onClick={()=>{changeActive(i)}}>{titles.title}</span>;
            })}
          </div>
          <div>
            {aboutus[activeTab].component}
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default Aboutus;
